<template>
  <div
    class="generate-voice dialog"
    @keydown.stop
  >
    <el-dialog
      v-bind="dialogProps"
      @close="close()"
      @open="onOpenDialog()"
      ref="dialogRef"
    >
      <div
        class="dialog__header"
        slot="title"
      >
        AI智能-输入文字 合成语音 ({{placeTexts[PreviewType]}})
        <div
          class="dialog__close"
          @click="close(true)"
        >
          <i class="icon-popup-close"></i>
        </div>
      </div>

      <div
        class="dialog__body"
        v-if="step.name === 'generate'"
      >
        <div class="row mb">
          <div class="row-item">
            <div class="row-item__name">音库</div>
            <div
              class="row-item__content"
              style="position: relative;"
            >
              <ReaderSelect
                v-model="reader"
                :options="readerOpts"
                :popper-append-to-body="false"
                placeholder="请选择"
                ref="readerSelect"
              >
                <Reader
                  v-for="item in readerOpts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :active="item.value === reader"
                  :item="item"
                ></Reader>
              </ReaderSelect>
              <div
                v-if="['x_yiping','x_mengmengneutral','x_xiaofang','x_xiaofeng','x_xiaoyan','xiaoguo', 'xiaojuan'].indexOf(readerObj.sourceId) > -1"
                style="color: #f9a66c;position: absolute;top: 110%;left: 6px;white-space: nowrap;"
              >该音库预计2020-11-17下架,建议更换音库。</div>
            </div>
          </div>
          <div class="row-item">
            <div class="row-item__name">语速</div>
            <div class="row-item__content df">
              <span>慢</span>
              <div
                :style="{width: '200px', padding: '0 10px'}"
                @mouseenter="sliderTipVisible = true"
              >
                <el-slider
                  v-model="speeds[readerObj.provider]"
                  :show-tooltip="sliderTipVisible"
                  :min="readerObj.minSpeed"
                  :max="readerObj.maxSpeed"
                ></el-slider>
              </div>
              <span>快</span>
            </div>
          </div>
        </div>
        <div
          class="row mb-small"
          style="position: relative;"
        >
          <div class="row-item">
            <div class="row-item__name">插入停顿</div>
            <div class="row-item__content df">
              <div
                class="btn-small margin"
                v-for="(item, i) in insertSpace"
                :key="i"
                @click="insertSpaceRecord({
                  sec: item.value
                })"
              >{{item.value + '秒'}}</div>
            </div>
          </div>

          <!-- 下拉菜单 -->
          <div class="menu-container row-item is-grow">
            <div class="name">特殊发音：</div>
            <Menu
              :title="'多音字'"
              :options="polyphoneList"
              @triggerOn="onPolyphoneMenuToggle"
              @clickItem="setCharPolyphone"
            >
              <template v-slot:icon>
                <iconfont
                  name="#iconduoyinzi"
                  font-size="16px"
                  style="margin-right: 2px;"
                ></iconfont>
              </template>
            </Menu>
            <div style="width: 24px;"></div>
            <Menu
              :title="'数字读法'"
              :options="numberList"
              @triggerOn="onNumberMenuToggle"
              @clickItem="setNumberSpeaking"
            >
              <template v-slot:icon>
                <iconfont
                  name="#iconshuzidufa"
                  font-size="20px"
                  style="margin-right: 6px;margin-top: 2.5px"
                ></iconfont>
              </template>
            </Menu>
          </div>

          <!-- <div
            class="row-item is-grow"
            v-if="readerObj.provider === 2"
          >
            <div class="row-item__name">语速</div>
            <div class="row-item__content df">
              <span>慢</span>
              <div :style="{width: '200px', padding: '0 10px'}">
                <el-slider
                  v-model="speeds[readerObj.provider]"
                  :show-tooltip="true"
                  :min="readerObj.minSpeed"
                  :max="readerObj.maxSpeed"
                ></el-slider>
              </div>
              <span>快</span>
            </div>
          </div>-->

          <div class="row-item mr">
            <div class="row-item__name is-small-margin">画面：</div>
            <div class="row-item__content">{{durations.scene}}秒</div>
          </div>
          <div
            class="row-item"
            v-show="durations.record && typeof (+durations.record) === 'number'"
          >
            <div class="row-item__name is-small-margin">录音：</div>
            <div class="row-item__content">{{durations.record || 0}}秒</div>
          </div>
        </div>
        <div class="textarea mb-medium">
          <textarea
            :placeholder="textarea.placeholder"
            @keydown.stop="limitTextarea($event)"
            @click="limitTextarea($event)"
            @select="onSelectText"
            @paste="onPaste"
            v-model="textarea.value"
            ref="textareaRef"
          ></textarea>
          <div class="textarea__tip">{{getTextLength(textarea.value)}}/{{textarea.maxlength}}字</div>
        </div>
        <div
          class="row"
          v-if="false"
        >
          <div class="row-item">
            <div class="play">
              <!-- 'is-disabled': !getTextLength(textarea.value) -->
              <div
                class="play__btn"
                :class="{'is-disabled': false, [playBtnShape]: true}"
                @click="
                  testPlay();
                  $analysis(toAnalysisParams('ai_dub，click_dub_video_preview，AI配音视频_预览'))
                "
                ref="testPlayBtn"
              >
                <!-- <i :class="playBtnShape"></i> -->
              </div>
              <span class="play__label">AI配音视频预览</span>
            </div>
          </div>
          <!-- 高级VIP无字数限制 -->
          <!-- <div class="row-item">
            还可以合成{{remainChars.generate}}字的音频
          </div>-->
        </div>
      </div>

      <!-- 命名录音 -->
      <div
        class="dialog__body"
        v-if="step.name === 'name'"
      >
        <name-content></name-content>
      </div>

      <div
        class="dialog__footer"
        slot="footer"
      >
        <div class="btns-wrapper">
          <div
            v-if="step.name === 'generate'"
            class="preview-0"
          >
            <div
              class="footer-btn"
              :class="{'is-disabled': !getTextLength(textarea.value)}"
              @click="
                  testPlay();
                  $analysis(toAnalysisParams('ai_dub，click_dub_video_preview，AI配音视频_预览'))
                "
              ref="testPlayBtn"
            >
              <iconfont
                name="#iconbofanganniu"
                font-size="18px"
                style="margin-right: 8px;"
              ></iconfont>试听预览
            </div>
          </div>
          <div
            v-if="step.name === 'generate'"
            class="submit-0"
          >
            <div
              class="footer-btn"
              :class="{'is-disabled': !getTextLength(textarea.value)}"
              @click="send();$analysis('ai_dub，click_dub_confirm，AI配音_合成')"
            >
              <iconfont
                name="#iconwanchengtianjiadaorushipin"
                font-size="18px"
                style="margin-right: 8px;"
              ></iconfont>添加到视频
            </div>
            <div
              v-if="this.UserLevelType < 2 && step.name === 'generate'"
              style="text-align: center; color: #606266; padding-top: 10px; font-size: 12px;"
            >
              剩余AI配音次数:
              <span style="color: #5778FB">{{remainChars.generate}}</span>次
            </div>
          </div>
          <div
            class="submit button--primary"
            v-if="step.name === 'name'"
            @click="createUserRecord()"
            :class="{'is-disabled': !isRecordNameValid}"
            style="margin-top: 28px; margin-bottom: 80px;"
          >确定</div>
        </div>
      </div>
    </el-dialog>

    <!-- 录音播放 -->
    <record-player
      ref="recordPlayer"
      @playStart="playStart"
      @loadedMeta="onLoadedMeta"
    ></record-player>

    <div
      class="progress"
      ref="progressRef"
      v-show="progressTip.isShow"
      style="position: fixed; top: 50%; left: 50%; width: 126px; height: 126px; transform: translate(-50%, -50%)"
    >
      <!-- <el-progress
        type="line"
        :stroke-width="12"
        :percentage="progressTip.percent"
        color="#5778fb"
        :show-text="false"
      ></el-progress>-->
      <div class="lds-default">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="progress__text">正在合成语音</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import nameContent from "./generateVoice/nameContent";
import recordPlayer from "./generateVoice/recordPlayer";
import analysis from "@/components/mixins/analysis/generateVoice";
import toAnalysisParams from "@/plugins/toAnalysisParams";
import ReaderSelect from "./generateVoice/readerSelect";
import Reader from "./generateVoice/reader";
import Menu from "./generateVoice/menu";

export default {
  mixins: [analysis],
  components: {
    nameContent,
    recordPlayer,
    ReaderSelect,
    Reader,
    Menu,
    iconfont: () => import('@/platformCode/iconfont')
  },
  props: {
    visible: Boolean
  },
  data () {
    return {
      dialogToTop: "60px",
      readerOpts: [
        {
          label: "林志玲",
          value: "lin"
        }
      ],
      reader: "",
      readerObj: {},
      speed: 100,
      speeds: {
        0: 5,
        2: 5
      },
      minSpeed: 0,
      maxSpeed: Infinity,
      insertSpace: [
        {
          value: 0.5
        },
        {
          value: 1
        },
        {
          value: 2
        }
      ],
      durations: {
        scene: 0,
        record: 0
      },
      textarea: {
        // placeholder: '来画君今天来上学，很高兴见到大家',
        placeholder: "请在此处输入文字...",
        // value: '的空[0.5秒]间[1秒]法式[2秒]咖啡',
        value: "",
        maxlength: 1000,
        cacheValue: ""
      },
      playBtnState: "play",
      playBtnShape: "icon-music-play",
      remainChars: {
        play: 0,
        generate: 0
      },
      step: {
        name: "generate" // generate | name
      },
      isGenerating: false,
      isGeneratingSuccess: false,
      fullscreenLoading: null,
      listenedParams: null,
      geneUrl: "",
      geneFileName: "",
      isRecordNameValid: true,
      progressTip: {
        percent: 0,
        isShow: false,
        tid: null
      },
      isLock: false,
      placeTexts: {
        global: "全局",
        scene: "单页"
      },
      polyphoneList: [],
      numberList: [
        { label: '数值读法', value: 2 },
        { label: '电报读法', value: 1 }
      ],
      sliderTipVisible: false
    };
  },
  computed: {
    dialogProps () {
      let { visible } = this;

      return {
        visible,
        width: "890px",
        "modal-append-to-body": false,
        "show-close": false,
        top: this.dialogToTop,
        "close-on-click-modal": false
      };
    },
    ...mapGetters([
      "Window_Size",
      "TOOL",
      "PreviewType",
      "SoundRecord",
      "UserLevel",
      "UserLevelType",
      "UserMsg",
      "IsDoingSmartVoice",
      "AIReader",
      "isPersonVip"
    ])
  },
  watch: {
    "textarea.value": function (val, old) {
      let textLen = this.getTextLength(val);
      let maxLen = this.textarea.maxlength;
      if (textLen > maxLen) {
        let valLen = this.textarea.value.length || 0;
        this.textarea.value = val.slice(0, maxLen + valLen - textLen);
        this.$message({
          message: `每次转换不能超过${maxLen}字`,
          type: "error"
        });
      }

      if (this.settingNumberSpeaking) {
        this.settingNumberSpeaking = false;
        return;
      }

      if (old.length > val.length) {
        return;
      }

      let startPos = this.$refs.textareaRef.selectionStart;
      let part = val.slice(0, startPos);
      let part0 = part.replace(/\[[0-9\.\[\]]*\u79d2\]/g, '');
      let pos = startPos - (part.length - part0.length);

      let { points } = this.decodeText();
      let sum = 0;
      let max = 20;
      let reader = (this.readerOpts.filter(v => v.value === this.reader) || [])[0];
      // if (reader.provider === 2) {
      //   max = 3;
      // }
      let cursor = this.$refs.textareaRef.selectionStart;
      // let k = window.clientInformation.clipboard.read()
      points.some((v, i) => {
        let prev = points[i - 1] || points[0];
        if (v.index !== prev.index) {
          sum = 0;
        }

        sum += v.duration;
        if (sum > max * 1000 && pos === v.index && val[startPos - 1] === ']' && val[startPos - 2] === '秒') {
          this.textarea.value = old; // this.shorten();
          let diffNum = val.length - old.length;
          let newPos = startPos - diffNum;
          let textareaRef = this.$refs.textareaRef;
          this.$nextTick(() => {
            textareaRef.focus();
            textareaRef.setSelectionRange(newPos, newPos);
          });
          // if (reader.provider === 2) {
          //   let names = this.getReaderNames().join('、') || '';
          //   this.showProviderPauseMsg({ max, names });
          // } else {
          //   this.$message.error({
          //     message: `累计添加的停顿不可超过${max}秒`
          //   });
          // }
          this.$message.error({
            message: `累计添加的停顿不可超过${max}秒`
          });
          return true;
        }
      });
    },
    isGenerating (val) {
      if (val) {
        this.fullscreenLoading = this.$loading({
          lock: true,
          spinner: "el-laihua-loading",
          text: "",
          customClass: "gene_recoring"
        });

        let mask = document.body.querySelector(".gene_recoring");
        this.$refs.progressRef.style.zIndex = mask.style.zIndex - 0 + 10;
        document.body.appendChild(this.$refs.progressRef);
        this.progressTip.isShow = true;
        // this.progressTip.percent = 0;
        // this.progressTip.tid = setInterval(() => {
        //   if (this.progressTip.percent < 40) {
        //     this.progressTip.percent += 10;
        //   }
        //   this.progressTip.percent < 85
        //     ? this.progressTip.percent++
        //     : (this.progressTip.percent += 0.1);
        //   this.progressTip.percent = Math.min(this.progressTip.percent, 90);
        // }, 500);
      } else {
        // if (this.isGeneratingSuccess) {
        //   this.progressTip.percent = 100;
        //   setTimeout(() => {
        //     this.progressTip.isShow = false;
        //     this.fullscreenLoading && this.fullscreenLoading.close();
        //   }, 500);
        // } else {
        // }

        this.progressTip.isShow = false;
        this.fullscreenLoading && this.fullscreenLoading.close();

        // clearInterval(this.progressTip.tid);
      }
    },
    reader: {
      handler (val) {
        this.$store.commit("set_Reader", val);
        let readerObj = (this.readerOpts.filter(r => {
          return r.value === val;
        }) || [])[0];
        this.readerObj = readerObj;
        this.minSpeed = readerObj.minSpeed;
        this.maxSpeed = readerObj.maxSpeed;
        this.textarea.maxlength = readerObj.maxSize;
        // if (this.readerObj.provider != 0) {
        //   this.textarea.value = this.decodeText().text;
        // }

        // if (readerObj.provider === 2) {
        //   let { points } = this.decodeText();
        //   let max = 3;
        //   let sum = 0;
        //   points.some((v, i) => {
        //     let prev = points[i - 1] || points[0];
        //     if (v.index !== prev.index) {
        //       sum = 0;
        //     }

        //     sum += v.duration;
        //     if (sum > max * 1000) {
        //       let names = this.getReaderNames().join('、') || '';
        //       this.showProviderPauseMsg({ max, names });
        //       return true;
        //     }
        //   })
        // }
      }
    },
    "SoundRecord.isShowGenerateVoice": {
      handler (val) {
        if (val) {
          this.$store.commit("set_IsDoingSmartVoice", {
            flag: true
          });
        }
      }
    }
  },
  created () {
    // this.getReaders();
    this.$bus.on("nameContent.validate", flag => {
      this.isRecordNameValid = flag;
    });
    $('body').on('mouseup', this.onBodyMouseUp);
  },
  mounted () {
    this.initView();
  },
  beforeDestroy () {
    $('body').off('mouseup', this.onBodyMouseUp);
  },
  methods: {
    toAnalysisParams (...args) {
      return toAnalysisParams(...args);
    },
    close (isEnd = false) {
      // this.$refs.recordPlayer.stop();
      if (this.step.name === "generate") {
        this.$emit("closeDialog");
      }
      if (this.step.name === "name") {
        // todo: save record
        this.createUserRecord();
        // this.step.name = 'generate';
      }
      if (isEnd) {
        this.$store.commit("set_IsDoingSmartVoice", {
          flag: false
        });
      }
    },
    initView () {
      this.setDialogTop();
      this.TOOL && this.getDurations();
      this.getRemainChars();
      // this.reader = this.readerOpts[0];
      this.$nextTick(() => {
        this.$refs.textareaRef && this.$refs.textareaRef.focus();
      });

      // 弹出气泡提示
      this.$bus.emit("showTips", {
        text: "在这里输入文字即可快速合成语音。",
        position: {
          top: `${window.innerHeight / 2 - 65}px`,
          left: `${window.innerWidth / 2 - 679}px`
        }
      });
    },
    onOpenDialog () {
      this.getReaders();
      this.initView();
    },
    setDialogTop () {
      this.$nextTick(() => {
        let parts =
          this.Window_Size.height -
          this.$refs.dialogRef.$refs.dialog.offsetHeight;
        let top = parts > 0 ? parts / 2 : 60;
        this.dialogToTop = top + "px";
      });
    },
    getReaders () {
      // this.$http.get('/api/user/kdxfaudio/source')
      this.$http
        .get("/api/user/audioAI/source")
        .then(res => {
          let { data } = res.data;
          this.readerOpts = data.map(read => {
            return {
              ...read,
              value: read.sourceId,
              label: read.sourceName
            };
          });
          if (this.AIReader) {
            this.reader = this.AIReader;
            this.$store.commit("set_Reader", "");
          } else {
            this.reader = this.readerOpts[0].value;
          }
        })
        .catch(this.err);
    },
    getRemainChars () {
      this.$http
        .get("/api/session/new")
        .then(res => {
          let { data, code, msg } = res.data;
          if (code !== 200) {
            throw new Error(msg);
          }
          let {
            kdxfRemain, // 剩余合成语音字数
            kdxfTimes // 剩余试听字数
          } = data;
          this.remainChars = {
            play: kdxfTimes,
            generate: kdxfRemain
          };
        })
        .catch(this.err);
    },
    onSelectChange () { },
    getDurations ({ record = 0 } = {}) {
      this.durations = {
        ...this.durations,
        ...{
          scene:
            this.PreviewType === "global"
              ? this.TOOL.getDuration() / 1000
              : this.TOOL.selectedScenes.getDuration() / 1000,
          record
        }
      };
    },
    getTextLength (text) {
      let pinyinRG = /\[\=[a-z]{1,6}[1-9]?\]/g;
      let numRG = /\[n[0-2]\]/g;
      // 秒 -- \u79d2
      //      let filtered = text.replace(/\[.*?秒\]/g, '');
      let filtered = this.decodeText().text;
      filtered = filtered.replace(pinyinRG, '').replace(numRG, '');
      return filtered.length;
    },
    getInsertSpaceSumTime (text) {
      text = text || this.textarea.value;
      let re = /\[([0-9\.]+)\u79d2\]/g;
      let arr = [];
      let sum = 0;
      text.replace(re, (m, c) => {
        sum = sum + (c - 0 || 0);
        arr.push(c - 0 || 0);
        return c + ",";
      });
      return {
        sum,
        arr
      };
    },
    insertSpaceRecord ({ sec = 0.5 } = {}) {
      let tpl = `[${sec.toFixed(1)}秒]`;
      let { textareaRef } = this.$refs;
      let startPos = textareaRef.selectionStart;
      let endPos = textareaRef.selectionEnd;
      // let re = new RegExp(`^([\\s\\S]{${startPos})([\\s\\S]*)}`)
      // this.textarea.value.replace(re, '$1' + tpl + '$2')
      let parts = [];
      parts.push(this.textarea.value.slice(0, startPos));
      parts.push(tpl);
      parts.push(this.textarea.value.slice(endPos));

      let part0 = parts[0].replace(/\[[0-9\.\[\]]*\u79d2\]/g, '');
      let diffLen = parts[0].length - part0.length;
      let pos = startPos - diffLen;

      let reader = (this.readerOpts.filter(v => v.value === this.reader) || [])[0];
      let max = 20;
      // if (reader.provider == 2) {
      //   max = 3;
      // }

      // if (this.getInsertSpaceSumTime(parts.join("")).sum > max) {
      //   this.$message.error({
      //     message: `累计添加的停顿不可超过${max}s`
      //   });
      //   return;
      // }
      let isBreakFn = false;
      let { points } = this.decodeText(parts.join(''));
      let sum = 0;
      points.some((v, i) => {
        let prev = points[i - 1] || points[0];
        if (v.index !== prev.index) {
          sum = 0;
        }

        sum += v.duration;
        if (sum > max * 1000 && pos === v.index) {
          isBreakFn = true;
          // if (reader.provider === 2) {
          //   let names = this.getReaderNames().join('、') || '';
          //   this.showProviderPauseMsg({ max, names });
          // } else {
          //   this.$message.error({
          //     message: `累计添加的停顿不可超过${max}s`
          //   });
          // }
          this.$message.error({
            message: `累计添加的停顿不可超过${max}s`
          });
          return true;
        }
      });

      if (isBreakFn) {
        return;
      }
      this.textarea.value = parts.join("");
      let newEndPos = parts[0].length + parts[1].length;
      this.$nextTick(() => {
        textareaRef.focus();
        textareaRef.setSelectionRange(newEndPos, newEndPos);
      });

      // report
      this.$analysis(this.ANALYSIS[`${sec}`]);
    },
    limitTextarea (ev) {
      const BACKSPACE = 8;
      const BL = 219; // 左中括号
      const BR = 221; // 右中括号
      const IME_KEY = 229;
      if (ev.keyCode >= 37 && ev.keyCode <= 40) {
        return;
      }
      if (ev.keyCode === BL || ev.keyCode === BR || ev.keyCode === 229) {
        ev.preventDefault();
      }
      let { textareaRef } = this.$refs;
      let startPos = textareaRef.selectionStart;
      let endPos = textareaRef.selectionEnd;
      let list = this.textarea.value.slice(0, startPos).match(/(\[)[^\]]*$/);
      let list2 = this.textarea.value.slice(endPos).match(/^[^\[]*(\])/);
      if (
        ev.keyCode === BACKSPACE &&
        this.textarea.value[startPos - 1] === "]" &&
        startPos === endPos
      ) {
        ev.preventDefault();
        let part = this.textarea.value
          .slice(0, startPos)
          .replace(/\[[^\[\]]*?\]$/, "");
        this.textarea.value =
          part + this.textarea.value.slice(textareaRef.selectionEnd);
        this.$nextTick(() => {
          textareaRef.setSelectionRange(part.length, part.length);
        });
      }
      if (list && list2) {
        startPos = list.index;
        endPos += list2[0].length;
        textareaRef.setSelectionRange(startPos, endPos);
        ev.preventDefault();
      } else if (
        ev.type !== "keydown" &&
        this.textarea.value[startPos] === "[" &&
        this.textarea.value[endPos - 1] === "]"
      ) {
        setTimeout(() => {
          textareaRef.setSelectionRange(startPos, endPos);
        }, 10);
        ev.preventDefault();
      }
    },

    toPreview (type) {
      this.$bus.emit("stop_listen_BGM");
      // 画布恢复正常大小
      if (this.TOOL.option.scale !== 1) {
        this.TOOL.setOption({
          width: this.Tool_Size.width,
          height: this.Tool_Size.height - 40,
          scale: 1,
          surplusY: this.TopNav_Size.height + 40,
          surplusX: this.MaterialPane_Size.width
        });
      }
      this.$bus.emit("Modal_vue", {
        name: "preview",
        data: {
          type: "record",
          select: type
        }
      });
    },
    testPlay_ (url) {
      let player = this.$refs.recordPlayer;
      if (player.playState === "play") {
        player.pause();
        return;
      }
      // 'http://oss.xfinfr.com/3B7Z8UMY/TtsResources/ca732d17-6476-4cc8-b5b7-31e008110ce9.mp3'
      url && player.changeFile(url);
      this.$nextTick(() => {
        // player.play();

        // to previwe
        this.close(false);
        const nameMap = {
          global: "all",
          scene: "select"
        };
        this.$store.commit("set_IsDoingSmartVoice", {
          flag: true,
          url: url || player.fileUrl
        });
        this.toPreview(nameMap[this.PreviewType]);
        this.$store.commit("set_Reader", this.reader);
      });
    },
    testPlay () {
      if (this.$refs.testPlayBtn.classList.contains("is-disabled")) {
        return;
      }
      let player = this.$refs.recordPlayer;
      if (player.playState === "play") {
        player.pause();
        return;
      }
      // if (this.textarea.cacheValue === this.textarea.value && player.fileUrl) {
      if (this.isNotMod()) {
        this.testPlay_();
        return;
      }
      let p = this.send({ type: 0 });
      p &&
        p.then(({ url }) => {
          this.textarea.cacheValue = this.textarea.value;
          this.testPlay_(this.$handleAssetsUrl(url));
        });
    },
    playStart ({ duration } = {}) {
      this.getDurations({
        record: duration || 0
      });
    },
    onLoadedMeta ({ duration } = {}) {
      this.playStart({ duration });
    },

    decodeText (inputText) {
      let text = inputText || this.textarea.value;
      let myText = text.replace(/\u79d2+(?=\])/g, "秒");
      myText = myText.replace(/\t|\s+/g, " ");
      let calcText = myText;
      let durs = [];
      let points = [];

      myText.replace(/\[[0-9\.\[\]]*\u79d2\]/g, (match, ...args) => {
        //        console.log(match, args)
        let parts = myText.split(match);
        myText = parts.join("");
        parts = calcText.split(match);
        calcText = parts.join("\t");
        // return parts.join('')
        durs.push(match.match(/[0-9\.]+/g));
      });
      //      console.log(myText, durs, calcText)
      let i = 0;
      calcText.replace(/\t/g, (...args) => {
        let numDur = durs[i].reduce((memo, v) => {
          return memo + (v - 0);
        }, 0);
        points.push({
          index: args[args.length - 2] - i,
          duration: (numDur <= 20 ? numDur : 20) * 1000
        });
        i++;
      });

      return {
        points,
        text: myText
      };
    },
    getRecordParams ({ kdxf } = {}) {
      let decoded = this.decodeText();
      let obj = {
        type: 0,
        text: decoded.text,
        speaker: this.reader,
        speed: this.speeds[this.readerObj.provider] + "",
        provider: this.readerObj.provider,
        pause_points: decoded.points
      };

      if (kdxf) {
        obj = {
          text: decoded.text,
          vol: 10,
          vcn: this.reader,
          speed: this.speed,
          auf: 2,
          aue: 1,
          pause_points: decoded.points
        };
      }
      return obj;
    },

    isNotMod () {
      return (
        JSON.stringify(this.listenedParams) ===
        JSON.stringify(this.getRecordParams())
      );
    },

    checkVip () {
      let popupShowed;
      let { kdxfRemain, kdxfTimes } = this.UserMsg;
      if (!kdxfRemain && this.UserLevelType < 1) {
        // this.$bus.emit("FeaturesPop_vue", {
        //   name: "vipEquity",
        //   msg: "升级个人VIP，解锁100次AI配音权益。",
        //   type: 2,
        //   btnMsg: "立即开通",
        //   btnMsgLink: "/vipsolo",
        //   baiduAction: "upgradeAidubVip",
        //   recommendVip: "AI配音无限次使用,点击了解高级会员。"
        // });
        this.$modal.show("vipDialog", {
          msg: "升级个人VIP，解锁240次AI配音权益。",
          target: "vipsolo",
          type: "solo",
          bottomLink: '/vip',
          bottomLinkText: 'AI配音无限次使用,点击了解高级会员。',
          trackingSource: 'AIVoice',
        });
        popupShowed = true;
      } else if (!kdxfRemain && this.UserLevelType === 1) {
        let temp = this.isPersonVip
          ? "您的视频无水印次数已用完，请购买资源包叠加权益或者开通企业会员无限使用。"
          : "开通企业会员可解锁AI智能配音功能。";
        // this.$bus.emit("FeaturesPop_vue", {
        //   name: "vipEquity",
        //   msg: temp,
        //   type: 2,
        //   btnMsg: "开通企业会员",
        //   btnMsgLink: "/vip",
        //   baiduAction: "upgradeAidubVip"
        // });
        this.$modal.show("vipDialog", {
          msg: temp,
          target: "vip",
          type: "vip",
          trackingSource: 'AIVoice',
        });
        popupShowed = true;
      }
      return popupShowed;
    },

    // 发送合成（试听）请求
    send ({
      type = 1 // 0 试听 | 1 合成
    } = {}) {
      let popupShowed = type === 1 ? this.checkVip() : false;
      if (popupShowed) {
        return;
      }
      const TEST = 0;
      const GENERATE = 1;
      let myResolve;
      let myReject;
      if (!this.getTextLength(this.textarea.value)) {
        return;
      }

      // report
      this.$analysis(this.ANALYSIS.generate);

      this.isGenerating = true;
      this.isGeneratingSuccess = false;
      let recordParams = this.getRecordParams();
      if (this.reader === 'x_catherine' && /[\u4e00-\u9fa5]/.test(recordParams.text)) {
        this.progressTip.isShow = false;
        this.isGenerating = false;
        this.$message({
          message: '该音库不支持中文，请输入英文。',
          type: "error"
        });
        return
      }
      let queryParams = {
        // data: this.getRecordParams(),
        // text: recordParams.text,
        ...recordParams,
        type,
        speaker: this.reader,
        speed: this.speeds[this.readerObj.provider] + "",
        provider: this.readerObj.provider
      };
      if (type == 1) {
        if (this.isNotMod()) {
          queryParams.isNotModified = true;
          queryParams.trialsUrl = this.geneUrl;
        } else {
          queryParams.isNotModified = false;
        }
      }
      this.$http
        .post("/api/user/audioAI", queryParams)
        .then(res => {
          let { data, code, msg } = res.data;
          if (typeof data === "string") {
            let str = data;
            data = {
              body: {
                url: str,
                filename: str
              }
            };
          }
          if (data.filename) {
            let str = data.filename;
            data = {
              body: {
                url: str,
                filename: str
              }
            };
          }

          if (code !== 200 || !data.body.url) {
            this.$message({
              message: msg || data.message,
              type: "error"
            });
            this.isGenerating = false;
            return;
          }

          data.body.url = this.$handleAssetsUrl(data.body.url);

          // this.getRemainChars();
          // if (code === 412) {
          //   // 用完了合成字数

          //   return;
          // }

          this.geneUrl = typeof data === "string" ? data : data.body.url;
          this.geneFileName =
            typeof data === "string" ? data : data.body.filename;
          if (type === GENERATE) {
            this.step.name = "name";
          }
          this.isGenerating = false;
          this.isGeneratingSuccess = true;

          if (type === 0) {
            this.listenedParams = queryParams;
          }

          let voiceUsing = Promise.resolve({});

          // 减少权益
          if (type === 1) {
            voiceUsing = this.$http.post("/api/user/audioAI/use", {
              kdxf: 1
            });
          }

          voiceUsing.then(({ resData }) => {
            this.$bus.emit("upDataUserMsg_vue");
            this.$bus.once("upDataUserMsg_vue_done", function hdr () {
              myResolve({
                url: typeof data === "string" ? data : data.body.url
              });
            });

            return resData;
          });
        })
        .catch(err => {
          this.$message({
            message: "系统开小差了",
            type: "error"
          });
          this.isGenerating = false;
          this.err(err);
          myReject(err);
        });

      return new Promise((resolve, reject) => {
        myResolve = resolve;
        myReject = reject;
      });
    },
    err (err) {
      console.warn(err);
    },

    async createUserRecord () {
      if (this.isLock) {
        return;
      }
      this.isLock = true;
      let contentComp = this.$refs.dialogRef.$children.filter(
        child => child.$options.name === "nameContent"
      )[0];
      let pass = contentComp.input.validate();
      let untitle;
      if (!pass) {
        this.isLock = false;
        return;
      }

      // report
      this.$analysis(this.ANALYSIS.confirm);

      let dur = await this.$util.getMediaDuration(
        this.$handleAssetsUrl(this.geneFileName)
      );
      if (!contentComp.input.value) {
        try {
          untitle = await this.getUntitle();
        } catch (err) {
          this.isLock = false;
        }
      }

      this.$http
        .post("/api/user/music", {
          url: this.geneFileName,
          title: contentComp.input.value || untitle,
          duration: dur,
          musicType: 1
        })
        .then(({ data: resData }) => {
          let { data, code, msg } = resData;
          if (code !== 200) {
            this.$message({
              message: msg,
              type: "error"
            });
            this.step.name = "generate";
            this.close(true);
            return;
          }
          this.step.name = "generate";
          this.close(true);
          this.textarea.value = "";

          // this.$bus.emit('generateVoice.updatedName');

          // 通知右侧栏
          this.$bus.emit("collectPersonal_vue", { data: "collectMusicType" });

          let rec = {
            // endTime: duration * 1000,
            fileType: data.fileType,
            id: data.id,
            resourceId: data.id,
            startTime: 0,
            title: data.title,
            url: this.$handleAssetsUrl(data.url)
          };

          // this.$bus.emit('FeaturesPop_vue', {
          //   name: 'volume_adjust',
          //   posx: 0,
          //   posy: 0,
          //   type: 1,
          // });

          // scene or global
          // if (contentComp.addedToPlace.place === 'global') {
          if (this.PreviewType === "global") {
            this.$bus.emit("addAudioToGlobal", rec);
          } else {
            this.$bus.emit("addAudioToScene", rec);
          }

          this.isLock = false;
        })
        .catch(err => {
          this.isLock = false;
        });
    },

    getUntitle () {
      let _y, _n;
      let sOfPage = 24;
      let pIndex = 1;
      let pad = n => {
        if (n < 10) {
          n = "0" + n;
        } else {
          n = "" + n;
        }
        return n;
      };

      let p = async prevResolve => {
        let yy = prevResolve;
        this.$http
          .get("/api/user/music", {
            params: {
              pIndex: pIndex,
              fPage: sOfPage,
              sOfPage: sOfPage,
              musicType: 1
            }
          })
          .then(res => {
            let { code, data, total } = res.data;
            let arr = data.filter(item => {
              return item.title && /未命名\d+$/.test(item.title);
            });

            if (pIndex * sOfPage > total && !arr[0]) {
              yy({
                title: "未命名00"
              });
              return;
            }
            // if (total > sOfPage) {
            if (!arr[0]) {
              // sOfPage *= 2;
              pIndex += 1;
              p(yy);
            } else {
              yy(arr[0]);
            }
          });

        return (
          !yy &&
          new Promise((y, n) => {
            yy = y;
          })
        );
      };

      p().then(item => {
        // let {code, data} = res.data;
        // let arr = data.filter((item) => {
        //   return item.title && /未命名\d+/.test(item.title);
        // });
        let num = item.title.replace(/^.*?(\d+)/, "$1") - 0;
        let title = `未命名${pad(num + 1)}`;
        _y(title);
      });

      return new Promise((resolve, reject) => {
        _y = resolve;
      });
    },

    async onSelectText (ev) {
      let el = ev.currentTarget;
      let s = el.selectionStart;
      let e = el.selectionEnd;
      let val = el.value;
      if (e - s === 1 && /[\u4e00-\u9fa5]/.test(val[s])) {
        // 获取读音
        let resp = await this.$http.get(`/api/user/audioAI/source/getPinyin?word=` + val[s]);
      } else {
        // this.$message({
        //   message: '请选中单个汉字之后使用多音字功能。',
        //   type: "error"
        // });
      }
    },
    setNumberSpeaking (item) {
      this.settingNumberSpeaking = true;
      let el = this.$refs.textareaRef;
      let { selectionStart, selectionEnd, value } = el;
      let selection = value.slice(selectionStart, selectionEnd) || '';
      let isNumber = /^[0-9]+$/.test(selection);
      if (selectionStart < selectionEnd && isNumber) {
        let parts = [];
        parts[0] = value.slice(0, selectionStart) || '';
        parts[1] = value.slice(selectionStart, selectionEnd) || '';
        parts[2] = value.slice(selectionEnd) || '';
        let tag = '[n' + item.value + ']'
        parts[1] = tag + parts[1] + tag;
        if (parts[0].slice(-4) === parts[2].slice(0, 4)) {
          parts[0] = parts[0].slice(0, -4);
          parts[2] = parts[2].slice(4);
        }
        this.textarea.value = parts.join('');
      } else {
        this.$message({
          message: '请选中数字之后使用数字读法功能。',
          type: "error"
        });
      }
    },
    setCharPolyphone (item) {
      let pinyinRE = /^\[\=[a-z]{1,6}[1-9]?\]/;
      let el = this.$refs.textareaRef;
      let { selectionStart, selectionEnd, value } = el;
      let selection = value.slice(selectionStart, selectionEnd) || '';
      let parts = [];
      parts[0] = value.slice(0, selectionEnd);
      parts[1] = value.slice(selectionEnd);
      let pinyin = '[=' + item.value + ']';
      parts[0] += pinyin;
      parts[1] = parts[1].replace(pinyinRE, '');
      this.textarea.value = parts.join('');
    },
    async getPolyphone () {
      let el = this.$refs.textareaRef;
      let { selectionStart, selectionEnd, value } = el;
      let selection = value.slice(selectionStart, selectionEnd) || '';
      if (selection.length === 1 && /[\u4e00-\u9fa5]/.test(selection)) {
        // 获取读音
        let resp = await this.$http.get(`/api/user/audioAI/source/getPinyin?word=` + selection);
        let polyphone = [];
        try {
          polyphone = resp.data.data.spell;
          polyphone = polyphone.split(',');
        } catch (e) {
          polyphone = [];
          this.$message({
            message: '您选中的汉字不是多音字哦',
            type: "error"
          });
        }
        this.polyphoneList = polyphone.map(item => {
          return {
            label: item,
            value: item
          }
        });
      } else {
        this.polyphoneList = [];
        this.$message({
          message: '请选中单个汉字之后使用多音字功能。',
          type: "error"
        });
      }
    },
    onPolyphoneMenuToggle (flag) {
      if (flag) {
        this.$refs.textareaRef.focus();
        this.getPolyphone();
      } else {
        this.polyphoneList = [];
      }
    },
    onNumberMenuToggle (flag) {
      if (flag) {
        this.$refs.textareaRef.focus();
      }
    },
    getReaderNames (provider = 2) {
      return this.readerOpts.filter(v => v.provider === provider).map(v => v.sourceName);
    },
    shorten (inputText) {
      let text = inputText || this.textarea.value;
      if (!text) {
        return;
      }
      // text.replace(/(\[[0-9\.\[\]]*\u79d2\])+/g, (...args) => {
      // })
      let obj = this.decodeText(text);
      let points = obj.points;
      if (points && !points.length) {
        return;
      }
      let max = 20;
      let reader = (this.readerOpts.filter(v => v.value === this.reader) || [])[0];
      if (reader.provider === 2) {
        max = 3;
      }
      let pauses = [];
      points.forEach(v => {
        if (pauses.indexOf(v.index) < 0) {
          pauses.push(v.index);
        }
      });
      let myPoints = [];
      pauses.forEach(v => {
        let fArr = points.filter(p => p.index === v);
        let sum = getSum(fArr, 'duration');
        while (sum > max * 1000) {
          fArr.pop();
          sum = getSum(fArr, 'duration');
        }
        myPoints = [...myPoints, ...fArr];
      });
      let gap = 0;
      let myText = obj.text;
      myPoints.forEach(v => {
        gap = myText.length - obj.text.length;
        let parts = [];
        parts[0] = myText.slice(0, v.index + gap);
        parts[1] = `[${(v.duration / 1000).toFixed(1)}秒]`
        parts[2] = myText.slice(v.index + gap);
        myText = parts.join('');
      });

      function getSum (arr, key) {
        let sum = 0;
        arr.forEach(v => {
          sum += v[key];
        });
        return sum;
      }

      return myText;
    },
    onPaste (e) {
      if (/^\[[0-9\.\[\]]*\u79d2\]$/.test(e.clipboardData.getData('Text'))) {
        e.preventDefault();
      }
    },
    onBodyMouseUp (e) {
      if (e.target.classList.contains('el-slider__button')) {
        return;
      }
      this.sliderTipVisible = false;
    },
    showProviderPauseMsg ({ max, names } = {}) {
      this.$modal.show('MessageDialog', {
        contentHtml: true,
        content:
          `因角色功能差异，下列角色不支持连续停顿超过${max}.0秒：${names}。<br/>如有较长停顿需求,请更换其他音色尝试~`,
        btns: [{ type: "custom", content: "知道了" }],
        resultHandler: type => {
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../style/colors";

.df {
  display: flex;
  align-items: center;
}

.mb {
  margin-bottom: 34px;
}

.mb-medium {
  margin-bottom: 20px;
}

.mb-small {
  margin-bottom: 10px;
}

.is-disabled {
  opacity: .5;
}

.dialog {
  &__close {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  &__header {
    position: relative;
    height: 40px;
    line-height: 40px;
    text-align: left;
    text-indent: 1.5em;
    background-color: $c8;
    border-radius: 4px 4px 0 0;
  }
  &__body {
    padding: 44px 44px 0;
  }
  &__footer {
    padding-top: 80px;
    padding-bottom: 50px;
  }
}

.row {
  display: flex;
  justify-content: space-between;
}

.row-item {
  display: flex;
  align-items: center;
  &.is-grow {
    flex-grow: 1;
  }
  &.mr {
    margin-right: 2em;
  }
  &__name {
    margin-right: 37px;

    &.is-small-margin {
      margin-right: 1em;
    }
  }
}

.btn-small {
  box-sizing: border-box;
  width: 50px;
  height: 30px;
  line-height: 30px;
  background-color: $c9;
  border: 1px solid $c8;
  border-radius: 4px;
  cursor: pointer;

  &.margin {
    margin-right: 10px;
  }
}

.textarea {
  position: relative;
  height: 140px;
  background-color: $c9;
  border-radius: 2px;
   > textarea {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 1em;
    margin: 0;
    background-color: transparent;
    border: none;
    resize: none;
  }

  &__tip {
    position: absolute;
    right: 1em;
    bottom: 1em;
    color: #aca8c4;
  }
}

.play {
  display: flex;
  align-items: center;
  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: $c12;
    border-radius: 30px;
    cursor: pointer;
     > i {
      transition-duration: .3s;
    }
  }

  &__label {
    margin-left: 1em;
  }
}

.btns-wrapper {
  display: flex;
  justify-content: center;
}

.submit {
  width: 160px;
  height: 40px;
  // background-color: $c2;
  color: $c0;
  line-height: 40px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;

  &.is-disabled {
    background-color: $c2;
    cursor: not-allowed;
  }
}

.footer-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 39px;
  color: #fff;
  background: #5778fb;
  border: 1px solid #5778fb;
  border-radius: 4px;
  cursor: pointer;
  &.is-disabled {
    cursor: not-allowed;
  }
  &:hover {
    background-color: #7d95f5;
    border-color: #7d95f5;
  }
  &.is-disabled {
    background: #5778fb;
  }
}
.preview-0 {
  margin-right: 60px;
  & > .footer-btn {
    color: #606266;
    background: #fff;
    border: 1px solid #d8dee9;
    &:hover {
      background: #fff;
      border-color: #5778fb;
    }
    &.is-disabled,
    &.is-disabled:hover {
      background: #fff;
      border-color: #d8dee9;
    }
  }
}


.progress {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__text {
    color: $c2;
    text-align: center;
  }
}

.lds-default {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 64px;
}
.lds-default div {
  position: absolute;
  width: 5px;
  height: 5px;
  background: $c2;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}
.lds-default div:nth-child(1) {
  top: 29px;
  left: 53px;
  animation-delay: 0s;
}
.lds-default div:nth-child(2) {
  top: 18px;
  left: 50px;
  animation-delay: -.1s;
}
.lds-default div:nth-child(3) {
  top: 9px;
  left: 41px;
  animation-delay: -.2s;
}
.lds-default div:nth-child(4) {
  top: 6px;
  left: 29px;
  animation-delay: -.3s;
}
.lds-default div:nth-child(5) {
  top: 9px;
  left: 18px;
  animation-delay: -.4s;
}
.lds-default div:nth-child(6) {
  top: 18px;
  left: 9px;
  animation-delay: -.5s;
}
.lds-default div:nth-child(7) {
  top: 29px;
  left: 6px;
  animation-delay: -.6s;
}
.lds-default div:nth-child(8) {
  top: 41px;
  left: 9px;
  animation-delay: -.7s;
}
.lds-default div:nth-child(9) {
  top: 50px;
  left: 18px;
  animation-delay: -.8s;
}
.lds-default div:nth-child(10) {
  top: 53px;
  left: 29px;
  animation-delay: -.9s;
}
.lds-default div:nth-child(11) {
  top: 50px;
  left: 41px;
  animation-delay: -1s;
}
.lds-default div:nth-child(12) {
  top: 41px;
  left: 50px;
  animation-delay: -1.1s;
}
@keyframes lds-default {
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}

.menu-container {
  width: 100px;
  height: 30px;
  padding-left: 20px;
}
</style>

<style lang="scss">
@import '../../style/colors';
.gene_recoring {
  > .el-loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;

    > .el-laihua-loading {
      display: none;
      position: static;
    }

    > .el-loading-text {
      // margin-left: 2em;
      color: $c2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/generateVoice.vue